<template>
  <SfDropdown
    align-option="l"
    drawer-direction="left"
    :dropdown-id="dropdownId"
    :is-open="isOpen"
    variant="seamless"
    class="period-selection-lock-type-dropdown"
    @dropdown-trigger-clicked="handleToggleDropdown"
  >
    <template #trigger>
      <span
        v-dompurify-html="title"
        :class="triggerClass"
        class="period-selection-item__title"
      >
      </span>
    </template>

    <template #menu>
      <SfDropdownItem
        v-for="lockTypeOption in lockTypeOptions"
        :key="lockTypeOption.key"
        :has-checkmark="selectedLockType === lockTypeOption.key"
        @click="handleLockTypeSelected(lockTypeOption.key)"
      >
        {{ lockTypeOption.title }}
      </SfDropdownItem>
    </template>
  </SfDropdown>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import type { LockType, PeriodSelectionOption } from '../types'
import { lockTypes } from '../types'

const I18n = useI18n()

interface Props {
  dropdownId: string
  isOpen: boolean
  isParentSelected: boolean
  periodSelectionOption: PeriodSelectionOption
  selectedLockType?: LockType
}
const props = defineProps<Props>()

const lockTypeScope = computed(
  () => `${props.periodSelectionOption.key}_options`
)

const lockTypeOptions = computed(() => [
  {
    key: lockTypes.LOCKED,
    title: I18n.t(
      `companies_overview.period_selection_new.${lockTypeScope.value}.locked`
    ),
  },
  {
    key: lockTypes.PERMANENTLY_LOCKED,
    title: I18n.t(
      `companies_overview.period_selection_new.${lockTypeScope.value}.permanently_locked`
    ),
  },
])

const title = computed(() =>
  I18n.t(props.periodSelectionOption.titleKey, {
    lockType: I18n.t(
      `companies_overview.period_selection_new.${lockTypeScope.value}.${props.selectedLockType}`
    ).toLowerCase(),
  })
)

const triggerClass = computed(() =>
  props.isParentSelected ? 'sf-font-medium' : 'sf-font-normal'
)

const emit =
  defineEmits<{
    'lock-type-selected': [lockType: LockType]
    'toggle-dropdown': []
  }>()

const handleLockTypeSelected = (lockType: LockType) => {
  emit('lock-type-selected', lockType)
}

const handleToggleDropdown = () => {
  emit('toggle-dropdown')
}
</script>
<style>
.period-selection-lock-type-dropdown .sf-dropdown2-menu {
  min-width: initial;
  width: auto;
}
</style>
